export default __webpack_public_path__ + "static/media/Navbarlogo.60f7c94c.jpeg";